/**
 * @generated SignedSource<<7126759884def4c38339fc036a963a87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTeamsVerificationKeyInput = {
  tenant?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createTeamsVerificationKeyMutation$variables = {
  input: CreateTeamsVerificationKeyInput;
};
export type createTeamsVerificationKeyMutation$data = {
  readonly createTeamsVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createTeamsVerificationKeyMutation = {
  variables: createTeamsVerificationKeyMutation$variables;
  response: createTeamsVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTeamsVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createTeamsVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createTeamsVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createTeamsVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df16df270a115d3df52240b4942c227b",
    "id": null,
    "metadata": {},
    "name": "createTeamsVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createTeamsVerificationKeyMutation(\n  $input: CreateTeamsVerificationKeyInput!\n) {\n  createTeamsVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "be4d14e2aaec5b65a72e8d19e450b866";

export default node;
